export default "__VITE_ASSET__U7_o_1Aq__"